import { useEffect, useRef } from 'react';
import { useLocale } from 'next-intl';

//* Styles
import NewsSectionStyle from './style';

//* Components
import Text from '@/components/Text';
import Editor from '@/components/Editor';
import Container from '@/components/Container';
import FileSection from '@/components/FileSection';
import useTrigger from '@/components/Animation/useTrigger';
import TextAnimation from '@/components/Animation/TextAnimation/TextAnimation';

//* Data
import { dataNews } from '@/data';

const NewsSection = () => {
	//! Navigation
	const lang = useLocale();

	//! Ref
	const styleRef = useRef();
	const titleRef = useRef();

	useEffect(() => {
		const trigger = useTrigger({
			ref: styleRef.current,
			once: true,
			documentPercent: 70,
			onEnter: () => {
				titleRef.current.children[0].classList.add('active');
				styleRef.current.classList.add('active');
			},
		});
		return () => {
			trigger();
		};
	}, []);

	return (
		<NewsSectionStyle ref={styleRef}>
			<Container isSection>
				<Container
					row
					full>
					<div className='col-6 col-m-12'>
						<Text
							ref={titleRef}
							tag={'h2'}
							className={'h3 font-montserrat-arm-medium uppercase'}>
							<TextAnimation text={dataNews[lang].title} />
						</Text>
					</div>
				</Container>

				<div className='news-list'>
					{dataNews[lang].news.map((item, index) => {
						return (
							<Container
								row
								full
								key={index}>
								<div className='file-block col-8 col-m-12'>
									<FileSection
										className={'file-animation'}
										file={item.file}
									/>
								</div>

								<div className='file-info-block col-4 col-m-12'>
									<div className='file-inner-info-block'>
										<div className='info-top-block'>
											<Text className={'h6 font-montserrat-arm-medium uppercase underline'}>{item.title}</Text>

											<Editor data={item.description} />
										</div>

										{/* <Text className={'p p2 hover-primary-color font-montserrat-arm-medium text-date underline'}>{item.date}</Text> */}
									</div>
								</div>
							</Container>
						);
					})}
				</div>
			</Container>
		</NewsSectionStyle>
	);
};

export default NewsSection;
